import { supabase } from './supabase';

export interface LeadCourseSelection {
  session_id: string;
  course_id: string;
  marketing_title: string;
  full_name: string;
  phone: string;
}

export interface CourseClickData {
  course_id?: string;
  course_name: string;
  course_type?: string;
  topic?: string;
  sub_topic?: string;
  position?: number;
  total_courses_shown?: number;
  mentor_name?: string;
  session_id?: string;
  user_id?: string;
  conversation_id?: string;
}

export interface SaveLeadCourseSelectionsResult {
  success: boolean;
  error?: string;
}

export async function saveLeadCourseSelections(
  selections: LeadCourseSelection[]
): Promise<SaveLeadCourseSelectionsResult> {
  try {
    console.log('[saveLeadCourseSelections] Saving selections:', selections);

    if (!selections || selections.length === 0) {
      return {
        success: false,
        error: 'No selections provided',
      };
    }

    const { data, error } = await supabase
      .from('lead_course_selections')
      .insert(selections)
      .select();

    if (error) {
      console.error('[saveLeadCourseSelections] Supabase error:', error);
      return {
        success: false,
        error: error.message,
      };
    }

    console.log('[saveLeadCourseSelections] Saved successfully:', data);

    return {
      success: true,
    };
  } catch (error: any) {
    console.error('[saveLeadCourseSelections] Unexpected error:', error);
    return {
      success: false,
      error: error.message || 'Unknown error occurred',
    };
  }
}

export async function trackCourseClick(
  clickData: CourseClickData
): Promise<SaveLeadCourseSelectionsResult> {
  try {
    console.log('[trackCourseClick] Tracking course click:', clickData);

    const { error } = await supabase
      .from('course_selections')
      .insert({
        course_id: clickData.course_id,
        course_name: clickData.course_name,
        course_type: clickData.course_type,
        topic: clickData.topic,
        sub_topic: clickData.sub_topic,
        position: clickData.position,
        total_courses_shown: clickData.total_courses_shown,
        mentor_name: clickData.mentor_name,
        session_id: clickData.session_id,
        user_id: clickData.user_id,
        conversation_id: clickData.conversation_id,
      });

    if (error) {
      console.error('[trackCourseClick] Supabase error:', error);
      return {
        success: false,
        error: error.message,
      };
    }

    console.log('[trackCourseClick] Tracked successfully');

    return {
      success: true,
    };
  } catch (error: any) {
    console.error('[trackCourseClick] Unexpected error:', error);
    return {
      success: false,
      error: error.message || 'Unknown error occurred',
    };
  }
}
